import {Table} from '@binance/uikit'
import {mediaJs} from 'utils/media'

export default function VTable ({...props}) {
  const mobile = mediaJs('tablet')
  const className = mobile ? '' : 'ReactVirtualized__fixed-table'
  return <Table className={className} {...props} />
}
